<template>
  <div>
    <div
      class="row"
    >
      <lead-card
        v-for="lead in leads"
        :key="lead.id"
        :lead="lead"
        deletable
        @delete="onDelete(lead)"
      />
    </div>

    <b-modal
      ref="delete-modal"
      title="Mentett kalkuláció törlése"
      show
      @ok="handleDelete"
    >
      Valóban törli ezt az ajánlatkérést?
    </b-modal>
  </div>
</template>

<script>
  import { Component, Vue } from 'vue-property-decorator';
  import { namespace } from 'vuex-class';

  const savedLeadsModule = namespace('leads');

  @Component
  export default class LeadList extends Vue {
    @savedLeadsModule.Getter('getItems') leads;
    @savedLeadsModule.Getter('isLoading') isLoading;
    @savedLeadsModule.Mutation('setUrl') setUrl;
    @savedLeadsModule.Action('fetchAllWithoutPagination') fetchAll;
    @savedLeadsModule.Action('deleteItem') deleteItem;

    created() {
      this.setUrl('/hu/profil/ajanlatok');
      this.fetchAll();
    }

    onDelete(lead) {
      this.lead = lead;
      this.$refs['delete-modal'].show();
    }

    handleDelete() {
      if (!this.lead) {
        return;
      }

      this.deleteItem(this.lead);
    }
  }
</script>
